import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Context from "../../context";
import DocumentViewerScreen from "../global/DocumentViewer";

const DocumentViewer = ({ type }) => {
  const [data, setData] = useState(null);

  const { itin } = useContext(Context);
  const { slideNum, docId } = useParams();

  useEffect(() => {
    const dayData = itin.brief[parseInt(slideNum) - 1];
    const documentItems = dayData.menu.filter(item => item.segue === 'documents' && item.segueId) ?? [];
    const dayDocuments = itin.documents.filter(doc => documentItems.some(item => item.segueId === doc.id && doc.type !=='remote'));

    let dayDocsData = [...dayDocuments];
    if (dayData?.locationId) {
      const location = itin.locations.find(loc => loc.id === dayData?.locationId);
      const locationPdfNode = itin.documents.find(doc => doc.id === location.pdfNodeId);
      if (locationPdfNode) dayDocsData = [...dayDocuments, locationPdfNode];
    }

    if (type === "poiDocuments" && parseInt(docId)) {
      const poiDoc = itin.documents.find(doc => doc.id === parseInt(docId));
      if (poiDoc) dayDocsData = [...dayDocsData, poiDoc];
    }

    setData(dayDocsData);
  }, [slideNum, itin.brief, itin.documents, itin.locations, type, docId]);

  if (!data) return <div>Loading</div>;

  return <DocumentViewerScreen type="dailyDocuments" dailyData={data} />
};

export default DocumentViewer;